// ALL FUNCTIONS RETURN
// VALID - NULL
// INVALID - ERROR STRING

/**
import { integerExp } from './regex';
 * @param value The numerical value that needs to be checked for integer
 * @returns return null if VALID; error message if INVALID
 */
export function isValidRegex(value: string, regex: RegExp): string | null {
	return regex.test(value) ? null : "value is not integer";
}

/**
 * @param value The value that is required
 * @returns return null if value is present; error message if value is blank
 */
export function required(value: any): string | null {
	return value === undefined || value === null || value === "" ? "value is required" : null;
}

/**
 * @param value The value that is to be validated
 * @param min Value should be less than this number
 * @returns return null if value is not present or if value is >= min; error message if value < min
 */
export function grtrThanEqTo(value: number, min: number): string | null {
	return value === undefined || value === null || value >= min ? null : "value should be greater";
}

/**
 * @param value The value that is to be validated
 * @param max Value should be greater than this number
 * @returns return null if value is not present or if value is <= max; error message if value > max
 */
export function lessThanEqTo(value: number, max: number): string | null {
	return value === undefined || value === null || value <= max ? null : "value should be smaller";
}

/**
 * @param value The value to be validated
 * @param multiple Value should be multiple of this value
 * @returns return null if value is not present or if value is multiple of `multiple`; error message otherwise
 */
export function multipleValidation(value: number, multiple: number): string | null {
	return value === undefined || value === null || value % multiple === 0 ? null : "value is not a multiple of " + multiple;
}
